import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';

import EditButton from '../../../common/button/EditButton';
import { PREVENTIVE_TASK_ASSIGNEE_PATH } from '../../../../config/paths';
import DeactivatePreventiveTaskAssigneeButton from './DeactivatePreventiveTaskAssigneeButton';

const PreventiveTaskAssigneeToolbar = ({ preventiveTaskAssigneeId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton
        path={`${PREVENTIVE_TASK_ASSIGNEE_PATH}/${preventiveTaskAssigneeId}/edit`}
      />{' '}
      <DeactivatePreventiveTaskAssigneeButton
        preventiveTaskAssigneeId={preventiveTaskAssigneeId}
      />
    </div>
  </ButtonToolbar>
);

PreventiveTaskAssigneeToolbar.propTypes = {
  preventiveTaskAssigneeId: PropTypes.number.isRequired,
};

export default PreventiveTaskAssigneeToolbar;
